import type {CopilotSpaceId} from '@github-ui/copilot-chat-types'
import {
  COPILOT_SPACES_COUNT_QUERY_KEY,
  COPILOT_SPACES_QUERY_KEY,
  deleteCopilotSpace,
} from '@github-ui/copilot-shared-ui/spaces/fetch'
import {useMutation, useQueryClient} from '@github-ui/react-query'

/**
 * Deletes a Copilot Space without requiring a CopilotChatManagerProvider. Use this on
 * surfaces (like the Spaces admin pages) that render outside the chat context.
 */
export function useDeleteCopilotSpace() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (item: CopilotSpaceId) => {
      const result = await deleteCopilotSpace(item)
      if (!result.ok) {
        throw new Error(result.error)
      }
      return {status: result.status, ok: true, payload: result.payload}
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: COPILOT_SPACES_QUERY_KEY})
      await queryClient.invalidateQueries({queryKey: COPILOT_SPACES_COUNT_QUERY_KEY})
    },
  })
}
